<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Message ref="message" severity="error" :closable="true" v-if="errors.length">{{ errors }}</Message>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="userid"
                    @sort="onSort($event)" :resizableColumns="true" columnResizeMode="fit">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="user_code" header="Username">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>

                    <Column field="user_name" header="Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>

                    <Column field="user_email" header="Email">
                        <template #body="slotProps">
                            {{ slotProps.data.user_email }}
                        </template>
                    </Column>

                    <Column field="user_level" header="User Level">
                        <template #body="slotProps">
                            {{ slotProps.data.user_level }}
                        </template>
                    </Column>

                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>

                    <Column field="mcuspv_name" header="SPV">
                        <template #body="slotProps">
                            {{ slotProps.data.mcuspv_name }}
                        </template>
                    </Column>

                    <Column field="status_user" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success"
                                v-if="slotProps.data.status_user == 'y'" />
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else />
                        </template>
                    </Column>
                    <Column header="Aksi" headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button class="p-button-rounded p-button-danger mr-2" @click="resetItem(slotProps.data)"
                                v-if="permission.includes('update')"> Reset Password </Button>
                            <Button class="p-button-rounded p-button-warning mr-2"
                                @click="resetSesiItem(slotProps.data)"
                                :disabled="!(permission.includes('update') && slotProps.data.can_reset == 'y')">
                                Reset Sesi
                            </Button>
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                @click="editItem(slotProps.data)" v-if="permission.includes('update')" />
                        </template>
                    </Column>
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Reset @submit="getDataTable()" :item="item" ref="reset" />

                <ResetSesi @submit="getDataTable()" :item="item" ref="resetSesi" />

                <Dialog v-model:visible="editItemDialog" :style="{ width: '450px' }" header="Data Detail" :modal="true"
                    class="p-fluid">

                    <div class="field">
                        <label>Status</label>
                        <Dropdown ref="dstatus" v-model="item.status_user" :options="dataDropdownStatus"
                            :class="{ 'p-invalid': errorEdit.status }" optionLabel="name" optionValue="code"
                            placeholder="Pilih Status" :showClear="true" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.status">{{ errorEdit.status[0]
                        }}</small>
                    </div>
                    <div class="field">
                        <label>Region</label>
                        <Dropdown id="region_id" ref="dreg" dataKey="region_id" v-model="item.region_id"
                            :loading="loadingDropdownRegion" :options="dataDropdownRegion" optionLabel="label"
                            optionValue="region_id" placeholder="Pilih Region" :filter="true"
                            :showClear="true" @filter="searchDropdownRegion($event, 'filter')" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.region_id">{{ errorEdit.region_id[0]
                            }}</small>
                    </div>
                    <template #footer>
                        <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                        <Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="updateItem"
                            :loading="loadingEdit" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';
import Reset from '../../components/master/user-app/Reset.vue';
import ResetSesi from '../../components/master/user-app/ResetSesi.vue';

export default {
    components: {
        'Reset': Reset,
        'ResetSesi': ResetSesi,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingEdit: false,
            loadingExcel: false,
            loadingCsv: false,
            loadingDropdownRegion: false,

            // dataDropdown
            dataDropdownRegion: null,
            dataDropdownStatus: [
                { name: 'Aktif', code: 'y' },
                { name: 'Nonaktif', code: 'n' },
            ],
            visibleSpvAdd: false,
            visibleSpvEdit: false,

            // edit
            item: {},
            editItemDialog: false,
            password: null,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
        this.$store.commit('setErrorAdd', {});
        this.$store.commit('setErrorEdit', {});
    },
    created(){
        this.searchDropdownRegion("");
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(['errors', 'errorEdit', 'errorAdd']),

        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        // RESET
        resetItem(item) {
            this.item = item;

            this.$refs.reset.resetItemDialog = true;
        },
        resetSesiItem(item) {
            this.item = item;

            this.$refs.resetSesi.resetSesiItemDialog = true;
        },
        // EDIT
        editItem(item) {
            this.item = item;

            this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialog() {
            this.editItemDialog = false;
            this.submitted = false;
        },
        updateItem() {
            this.loadingEdit = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userapp/update-status',
                data: {
                    "userid": this.item.userid,
                    "status": this.item.status_user,
                    "region_id": this.item.region_id,
                },
            })
                .then((res) => {
                    this.loadingEdit = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorEdit', {});
                        this.item = {};
                        this.editItemDialog = false;
                        this.getDataTable();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loadingEdit = false;
                    this.$store.commit('setErrorEdit', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000, });
                });
        },
        // DATATABLE
        getDataTable() {

            this.loading = true;
            this.page = (this.offset / this.rows) + 1;


            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userapp',
                params: {
                    "search": this.search,
                    "per_page": this.rows,
                    "page": this.page,
                    "order_by": this.field,
                    "sort_by": this.sort,
                }
            })
                .then(res => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                });

        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {

            if (ext == 'xlsx') {
                this.loadingExcel = true;
            } else if (ext == 'csv') {
                this.loadingCsv = true;
            }

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userapp/export',
                responseType: 'blob',
                params: {
                    "ext": ext,
                }
            })
                .then(response => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement('a');

                    fileLink.href = fileUrl;

                    fileLink.setAttribute('download', 'Master User App Export.' + ext);

                    document.body.appendChild(fileLink)

                    fileLink.click();

                    if (ext == 'xlsx') {
                        this.loadingExcel = false;
                    } else if (ext == 'csv') {
                        this.loadingCsv = false;
                    }

                })
                .catch((err) => {
                    console.log(err);

                    if (ext == 'xlsx') {
                        this.loadingExcel = false;
                    } else if (ext == 'csv') {
                        this.loadingCsv = false;
                    }
                });
        },

        // DROPDOWN
        searchDropdownRegion(event, purpose, valueEdit) {
            setTimeout(() => {
                if (valueEdit) {
                    this.$refs.dreg.filterValue = valueEdit;
                }

                if (purpose == "filter") {
                    this.loadingDropdownRegion = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/select2/region",
                    params: {
                        search: valueEdit ? valueEdit : event.value
                    },
                })
                    .then((res) => {
                        if (purpose == "filter") {
                            this.dataDropdownRegion = res.data.data;
                            this.loadingDropdownRegion = false;
                        } else if (purpose == null) {
                            this.dataDropdownRegion = res.data.data;
                        } else if (purpose == "edit") {
                            this.dataDropdownRegion = res.data.data;
                            this.loadingDropdownRegion = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
    }
}
</script>